import { useCallback, useState } from 'react';
import { downloadFileDirectly } from '@/lib/api/utils';
import { getHighlyConfidentialFileContent } from '../api';
interface ConfidentialFileInfo {
  s3Url: string;
  originalName: string;
  mimeType?: string;
}

/**
 * 高機密ファイルをダウンロードするフック
 */
export const useDownloadConfidentialFile = () => {
  const [isDownloading, setIsDownloading] = useState(false);
  const download = useCallback(async (fileInfo: ConfidentialFileInfo) => {
    const {
      s3Url,
      originalName,
      mimeType
    } = fileInfo;
    const fileName = decodeURIComponent(originalName);
    setIsDownloading(true);
    try {
      const blobUrl = await getHighlyConfidentialFileContent(s3Url, fileName, mimeType || 'application/octet-stream');
      downloadFileDirectly(blobUrl, fileName);
    } catch (error) {
      console.error('ファイルの取得に失敗しました:', error);
    } finally {
      setIsDownloading(false);
    }
  }, []);
  return {
    download,
    isDownloading
  };
};